export default __webpack_public_path__ + "static/media/hogeschool-bubbles.c878841b.png";